import moment from 'moment';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { hotelTourOptionPropTypes } from './PropTypes';

import {
  currencyDepositAndTotalPricePropTypes,
  getPricePerPaxTypePerCurrency,
} from '../../../util/currency';
import UpgradeCard from '../BookingFieldset/UpgradeCard';
import { withErrorBoundary } from '../Core/ErrorBoundary';
import { portalNodeType } from '../../../util/sharedPropTypes';

const propTypes = exact({
  closeModalText: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([undefined])]),
  currencyPriceSetting: currencyDepositAndTotalPricePropTypes.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  portalNode: portalNodeType.isRequired,
  groupKey: PropTypes.string.isRequired,
  handleOptionSelect: PropTypes.func.isRequired,
  optionAddedText: PropTypes.string,
  options: PropTypes.arrayOf(hotelTourOptionPropTypes).isRequired,
  perPersonText: PropTypes.string,
  priceFromText: PropTypes.string,
  selectedKey: PropTypes.string.isRequired,
  soldOutText: PropTypes.string,
  viewDetailsCtaText: PropTypes.string,
});

const defaultProps = {
  optionAddedText: 'Option added',
  soldOutText: 'Sold out',
  viewDetailsCtaText: 'View Details',
  perPersonText: 'pp',
  priceFromText: 'Price From',
  closeModalText: undefined,
};

function HotelGroup(props) {
  const {
    portalNode,
    groupKey,
    handleOptionSelect,
    currencyPriceSetting,
    currencySymbol,
    perPersonText,
  } = props;

  return (
    <div className="UpgradeGroup">
      <div className="UpgradeGroup_itemGroup">
        {props.options.map((hotelTourOption) => {
          const checkInDate = moment(hotelTourOption.checkInDate);
          const checkOutDate = moment(hotelTourOption.checkOutDate);

          const modalProps = {
            images: hotelTourOption.option.images,
            title: hotelTourOption.option.heroBannerTitleText,
            subTitle: hotelTourOption.option.heroBannerSubtitleText,
            desc: hotelTourOption.option.heroBannerDescription,
            content: hotelTourOption.option.modalContent,
            price: hotelTourOption.price,
            durationMin:
              checkOutDate.isValid() && checkInDate.isValid()
                ? checkOutDate.diff(checkInDate, 'days')
                : null,
            durationMax:
              checkOutDate.isValid() && checkInDate.isValid()
                ? checkOutDate.diff(checkInDate, 'days')
                : null,
            priceFromText: props.priceFromText,
            portalNode,
          };

          const currencyPriceSettingPrice = getPricePerPaxTypePerCurrency(
            hotelTourOption.pricePerPax[0].pricePerCurrency,
            currencyPriceSetting.currency
          );

          return (
            <div
              className="UpgradeGroup_item UpgradeGroup_item-fullWidth"
              key={hotelTourOption.option.key}
            >
              <UpgradeCard
                blockName="UpgradeGroup_card"
                closeModalText={props.closeModalText}
                currencySymbol={currencySymbol}
                description={hotelTourOption.option.fullDescription}
                handleClick={() => handleOptionSelect(groupKey, hotelTourOption.option.key)}
                images={hotelTourOption.option.images}
                isSelected={hotelTourOption.option.key === props.selectedKey}
                limitedAvailability={hotelTourOption.limitedAvailability}
                limitedAvailabilityText={hotelTourOption.limitedAvailabilityText}
                limitedAvailabilityRemainingSpaces={
                  hotelTourOption.limitedAvailabilityRemainingSpaces
                }
                limitedAvailabilityRemainingText={hotelTourOption.limitedAvailabilityRemainingText}
                modalProps={modalProps}
                perPersonText={perPersonText}
                price={currencyPriceSettingPrice}
                pricePerPerson
                rating={hotelTourOption.option.rating}
                selectedText={props.optionAddedText}
                soldOut={!!hotelTourOption.soldOut}
                soldOutText={props.soldOutText}
                title={hotelTourOption.option.title || 'hotelTourOption.option.title missing'}
                type={hotelTourOption.option.type}
                viewDetailsCtaText={props.viewDetailsCtaText}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

HotelGroup.propTypes = propTypes;
HotelGroup.defaultProps = defaultProps;

export default withErrorBoundary(HotelGroup);
